import { Autocomplete, CircularProgress, TextField } from "@mui/material"
import { useEffect, useMemo, useState } from "react";
import { Environment } from "../../environment";
import { UnidadeService } from "../../services/api/unidade/UnidadeService";
import { AlertSnackBar } from "../alert/AlertSnackBar";
import { AutoCompleteDeCliente } from "./AutoCompleteDeCliente";

type AutoCompleteOption = {
  id: number; // apenas algo que diferencie as opções, o valor q vai ser retornado ao escolher
  label: string;
}

interface IAutoComplete {
  /**
   * Deixa o autocomplete desabilitado
   */
  disabled?: boolean,
  /**
   * Fazer com que tenha a indicação que está carregando 
   */
  isExternalLoading?: boolean,
  /**
   * Altera o size do campo (para cadastro o tamanho é médio)
   */
  paraCadastro?: boolean,
  /**
   * Width do campo(padrão 200), null para não ter width e variar de acordo com a tela
   */
  width?: number | null,
  /**
   * Pegar o valor que vai retornar ao trocar opção
   */
  selectedIdUnidade?: (idUnidade: number | undefined) => void,
}

/**
 * selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} \
 * para pegar o valor selecionado e colocar em uma variável/state
 */

export const AutoCompleteDeUnidade: React.FC<IAutoComplete> = ({ disabled = false, isExternalLoading = false, paraCadastro = false, width = 200, selectedIdUnidade }) => {
  useEffect(() => {
    selectedIdUnidade?.(Number(localStorage.getItem('idUnidade')));
  }, [])

  const [selectedId, setSelectedId] = useState<number | null | undefined>(Number(localStorage.getItem('idUnidade')));

  const [opcoes, setOpcoes] = useState<AutoCompleteOption[]>([]);
  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);
  const [isLoading, setIsLoading] = useState(isExternalLoading);

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  useEffect(() => { // consulta para o autocomplete
    if (cnpj === undefined || cnpj === null || cnpj == '') {
      setOpcoes([]);
      selectedIdUnidade?.(0);
    } else {
      setIsLoading(true);
      UnidadeService.list(cnpj).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setOpcoes([]);
          setSelectedId(undefined);
          localStorage.removeItem('idSetor');

          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);

        } else {
          setOpcoes(result.map(unidade => ({ id: unidade.idUnidade, label: unidade.nomeUnidade })));
        }
      });
    }
  }, [cnpj]);

  useEffect(() => {
    if (localStorage.getItem("idUnidade") === null) {
      setSelectedId(undefined);
    }
  }, [localStorage.getItem("idUnidade")]);


  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.id === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <>
      {paraCadastro ? (
        <AutoCompleteDeCliente paraCadastro selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />
      ) : (
        <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />
      )}

      {alertSnackbar !== undefined && (
        <>
          {alertSnackbar.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alertSnackbar.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      {cnpj !== undefined && cnpj !== null && cnpj !== '' && (
        <Autocomplete
          //traduzir textos
          openText="Abrir"
          closeText="Fechar"
          noOptionsText="Sem opções"
          loadingText="Carregando..."

          disablePortal

          //estilização
          sx={{ width: width }}
          loading={isLoading}
          popupIcon={isLoading ? <CircularProgress size={20} /> : undefined}//trocar o icone enquanto carrega os dados

          //dados
          options={opcoes}
          onChange={(_, newValue) => {
            selectedIdUnidade?.(newValue?.id);
            setSelectedId?.(newValue?.id);
            if (newValue?.id) {
              localStorage.setItem('idUnidade', `${newValue.id}`);
            } else {
              localStorage.removeItem('idUnidade');
              localStorage.removeItem('idSetor');
            }
          }}
          value={autoCompleteSelectedOption}
          renderInput={(params) => <TextField {...params} label="Área" placeholder="Digite o nome..." size={paraCadastro ? 'medium' : 'small'} />}
        />
      )}
    </>
  );
}